import { connect } from 'react-redux'
import TemporaryLaunchFrame from './component'
import { actions, selectors, getAttributes } from '../../../../imports'
import {
    setUserTokens,
    getUserRefreshToken,
    getErrorAutoRefreshText,
    getErrorRefreshingText,
} from '../../../../data'

export function mapStateToProps(state, ownProps) {
    const { userId, unMount } = ownProps
    const server = selectors.getActiveServer(state)
    const locale = selectors.getLocale(state)
    const attributes = getAttributes(locale)
    let refreshTokenService = ''
    if (server.sso.slinger !== undefined) {
        refreshTokenService = attributes.slingerRefresh.replace('{host}', server.sso.slinger)
    }

    return {
        userId,
        refreshToken: getUserRefreshToken(state, server.serverId, userId),
        refreshTokenService,
        unMount,
        locale,
    }
}

const setTokens = (userId, access, refresh) => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(setUserTokens(serverId, userId, { access, refresh }))
}

const displayAutoRefreshFail = () => (dispatch, getState) => {
    const message = getErrorAutoRefreshText(getState())
    dispatch(actions.addError(message))
}

const displayRefreshingError = () => (dispatch, getState) => {
    const message = getErrorRefreshingText(getState())
    dispatch(actions.addError(message))
}

const setLaunchProgress = (userId, progress) => (dispatch, getState) => {
    const serverId = selectors.getActiveServerId(getState())
    dispatch(actions.setClientLaunchProgress(serverId, userId, progress))
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        setTokens: (access, refresh) => {
            dispatch(setTokens(ownProps.userId, access, refresh))
        },
        displayAutoRefreshFail: () => dispatch(displayAutoRefreshFail()),
        displayRefreshingError: () => dispatch(displayRefreshingError()),
        setClientLaunchProgress: (progress) => {
            dispatch(setLaunchProgress(ownProps.userId, progress))
        },
        showEulaPrompt: (userId, hash, accepted) => {
            dispatch(actions.showEulaPrompt(userId, hash, accepted))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TemporaryLaunchFrame)



// WEBPACK FOOTER //
// ./src/features/Users/components/UserList/components/TemporaryLaunchFrame/index.js